import { LayoutComponent } from "../../../components";
import { Outlet } from "react-router-dom";

export function AdminLayoutView() {
  return (
    <LayoutComponent selectedMenuItem={"admin"}>
      <Outlet />
    </LayoutComponent>
  );
}
